export default "/_next/static/chunks/fonts/FontAwesome5_Regular-1017bce89c72f95bcf8e2bf4774efdbf.ttf";